async function reviewsSchema() {
  const productContainer = document.querySelector('[data-main-product-info]');
  if(!productContainer) return;
  const product = decodeBase64Json(productContainer.dataset.mainProductInfo);
  const url = `https://api-cdn.yotpo.com/v1/widget/VYzloCkQ7L3qM6pCNhTAyzuosPtaVAn3xyj3cGod/products/${product.id}/reviews.json?per_page=20&star=5`;
  const options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    }
  };
  const request = await fetch(url, options);
  const result = await request.json();
  if(result.status.code !== 200 || result.response.reviews.length === 0) return;
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.title,
    "description": product.description,
    "image": product.featured_image,
    "offers": {
      "@type": "Offer",
      "availability": product.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "price": product.price,
      "priceCurrency": product.priceCurrency,
      "url": product.url
    },
    "review": []
  }
  const ratingObject = result.response.bottomline;
  const reviews = result.response.reviews;
  schema.aggregateRating = {
    "@type": "AggregateRating",
    "ratingValue": ratingObject.average_score.toFixed(1),
    "reviewCount": ratingObject.total_review,
  }
  const schemaReviews = reviews.map(review => ({
    "@type": "Review",
    "name": review.title || "",
    "reviewBody": review.content,
    "datePublished": review.created_at.split('T')[0],
    "author": {
      "@type": "Person",
      "name": review.user.display_name
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": review.score
    }
  }))

  schema.review = schemaReviews;
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.innerHTML = JSON.stringify(schema);
  document.body.appendChild(script);
}

function decodeBase64Json(base64) {
  const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  const jsonString = new TextDecoder("utf-8").decode(bytes);
  return JSON.parse(jsonString);
}

document.addEventListener('DOMContentLoaded', async ()=> await reviewsSchema());
